import { isNil } from 'es-toolkit';

import { CLIENT_STAGE_FULLY_ONBOARDED } from '@savvy/constants/client-stages';

import { CLIENT_PORTAL_HOME_ROUTE } from '../components/shell/constants';

type ClientLandingInput = {
  readonly clientStage: string | null | undefined;
  readonly isSmallScreen: boolean;
  readonly personalPortfolioId: string | null | undefined;
};

export function clientLandingRoute({ clientStage, isSmallScreen, personalPortfolioId }: ClientLandingInput): string {
  if (clientStage === CLIENT_STAGE_FULLY_ONBOARDED && isSmallScreen && !isNil(personalPortfolioId)) {
    return `/savvy-portfolio/${personalPortfolioId}`;
  }
  return CLIENT_PORTAL_HOME_ROUTE;
}
